import React from 'react';
// import PropTypes from 'prop-types';

const CanMassActions = ({
  children,
  can,
}) => (
  <React.Fragment>
    {can && children}
  </React.Fragment>
);

CanMassActions.propTypes = {
};

export default CanMassActions;



// WEBPACK FOOTER //
// ./src/components/list/canMassActions/CanMassActions.jsx